<template>
	<transition 
			appear
			:appear-active-class="$_point_stylePageAnimation()">
		<template v-if="initialized_">
			<v-container 
					class="customVContainer fluid"
					:style="$_point_stylePageContainerStyle()"
					fluid>
				<v-row	v-show="isFalse(onLogin_)"
						no-gutters>
					<v-col>
						<iframe	class="iframe_"
								frameborder="0"	
								scrolling="auto"
								:src="url_" />
					</v-col>
				</v-row>
				<template v-if="onLogin_">
					<v-row class="customVRow">
						<v-col cols="12" class="center">
							<progress-circular :text="'Almost done. Loading reward point website...'" />
						</v-col>
					</v-row>
				</template>
				<point-input-voucher-code-dialog />
			</v-container>
		</template>
		<template v-else>
			<v-row class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular :text="'Initializing point information. This may take a few minutes...'" />
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'Point',
		props: {
			inits: Object
		},
		data() {
			return {
				pageName_: 'point',
				pageType_: 'point',

				initialized_: false,

				onLogin_: false,

				url_: null
			}
		},
		computed: {
			// current user
			$_point_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_point_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			$_point_stateUserUsername() {
				const self_ = this;
				return self_.getUserState('username')
			},
			// contents / inits
			$_point_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_point_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_point_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_point_inits(), 'contact')
			},
			// style
			$_point_stylePage() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_point_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_point_inits(), 'page')
				}
			},
			$_point_stylePageAnimation() {
				const self_ = this;
				return () => {
					const page_ = self_.$_point_stylePage()
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.animation)
				}
			},
			$_point_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_point_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_point_inits(), 'pageContainer')
			},
			$_point_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_point_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_point_setPageState()

			if(self_.$_point_statePageIsInitialized) { 
				self_.initialized_ = true;

				self_.$_point_loadIpcUrl()
			} else {
				self_.$_point_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_point_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_point_initialize() {
				const self_ = this;

				const uid_ = self_.$_point_currentUserUid;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					return self_.updatePointExpiration(uid_)
				}).then(() => {
					return self_.updateUserPointData(uid_)
				}).then(() => {
					return self_.initializeUser('pointData')
				}).then(() => {
					self_.initialized_ = true;

					self_.$_point_loadIpcUrl()
				}).catch(error => {
/* error */			self_.logError('Error', '$_point_initialize()', error)
				})
			},
			$_point_loadIpcUrl() {
				const self_ = this;

				self_.onLogin_ = true;

				const username_ = self_.$_point_stateUserUsername;
				const password_ = self_.$_point_currentUserUid;

				// custom for bri life start
				// self_.url_ = self_.ipcUrl + '/auth/login?username=' + encodeURIComponent(username_) + '&password=' + encodeURIComponent(password_)
				const securityGroup_ = self_.getUserState('securityGroupCode')
				if(securityGroup_ == 'ibs' || securityGroup_ == 'adminibs') {
					self_.url_ = 'https://' + self_.ipcDomain + '-ibs.bo-point.id' + '/auth/login?username=' + encodeURIComponent(username_) + '&password=' + encodeURIComponent(password_)
				}
				else if(securityGroup_ == 'agency' || securityGroup_ == 'adminagency') {
					self_.url_ = 'https://' + self_.ipcDomain + '-agency.bo-point.id' + '/auth/login?username=' + encodeURIComponent(username_) + '&password=' + encodeURIComponent(password_)
				}
				else if(securityGroup_ == 'test') {
					self_.url_ = 'https://' + self_.ipcDomain + '-test.bo-point.id' + '/auth/login?username=' + encodeURIComponent(username_) + '&password=' + encodeURIComponent(password_)
				}
				else {
					self_.url_ = self_.ipcUrl + '/auth/login?username=' + encodeURIComponent(username_) + '&password=' + encodeURIComponent(password_)
				}
				// custom for bri life end

/* debug */		self_.logDebug('IPC Login', '', { url: self_.url_ })

				setTimeout(() => {
					// custom for bri life start
					// self_.url_ = self_.ipcUrl;
					const securityGroup_ = self_.getUserState('securityGroupCode')
					if(securityGroup_ == 'ibs' || securityGroup_ == 'adminibs') {
						self_.url_ = 'https://' + self_.ipcDomain + '-ibs.bo-point.id';
					}
					else if(securityGroup_ == 'agency' || securityGroup_ == 'adminagency') {
						self_.url_ = 'https://' + self_.ipcDomain + '-agency.bo-point.id';
					}
					else if(securityGroup_ == 'test') {
						self_.url_ = 'https://' + self_.ipcDomain + '-test.bo-point.id';
					}
					else {
						self_.url_ = self_.ipcUrl;
					}
					// custom for bri life end

					self_.onLogin_ = false;
				}, 5000)
			}
		}
	}
</script>

<style scoped>
	@media screen and (min-width:960px) {
		.iframe_ {
			margin-bottom: -32px;

			height: calc( ( 100vh - 64px ) ) !important;
			width: 100vw;
		}
	}
	@media screen and (max-width:959px) {
		.iframe_ {
			margin-bottom: -24px;

			height: calc( ( 100vh - 56px ) ) !important;
			width: 100vw;
		}
	}
</style>
